module.exports = __webpack_public_path__ + "img/71.1.8604c572.jpg";